module.exports = __webpack_public_path__ + "static/media/bg-desk.f9cdaf7a.svg";